import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  MenuItem,
  Chip
} from "@mui/material";

const OvertimeAdmin = () => {
  const baseURL = process.env.REACT_APP_API_URL;

  const [overtimes, setOvertimes] = useState([]);
  const [filters, setFilters] = useState({
    employee: "",
    date: "",
    status: ""
  });

  // 🔹 Fetch OT
  const fetchOT = async () => {
    try {
      const res = await axios.get(`${baseURL}overtime`, {
        params: filters
      });
      setOvertimes(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchOT();
  }, []);

  // 🔹 Filter change
  const handleFilter = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // 🔹 Approve / Reject
  const updateStatus = async (id, status) => {
    await axios.put(`${baseURL}overtime/${id}`, { status });
    fetchOT();
  };

  const getStatusColor = (status) => {
    if (status === "approved") return "success";
    if (status === "rejected") return "error";
    return "warning";
  };

  return (
    <Box sx={{ p: 3 }}>
      <h2>Overtime Management</h2>

      {/* 🔍 Filters */}
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <TextField
          label="Employee"
          name="employee"
          value={filters.employee}
          onChange={handleFilter}
        />

        <TextField
          type="date"
          name="date"
          value={filters.date}
          onChange={handleFilter}
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          select
          label="Status"
          name="status"
          value={filters.status}
          onChange={handleFilter}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="approved">Approved</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
        </TextField>

        <Button variant="contained" onClick={fetchOT}>
          Search
        </Button>
      </Box>

      {/* 📊 Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Employee</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Working Hrs</TableCell>
              <TableCell>OT Hrs</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {overtimes.map((ot) => (
              <TableRow key={ot.id}>
                <TableCell>{ot.employee_name}</TableCell>
                <TableCell>{ot.date}</TableCell>
                <TableCell>{ot.working_hours}</TableCell>
                <TableCell>{ot.overtime_hours}</TableCell>
                <TableCell>{ot.overtime_type}</TableCell>
                <TableCell>{ot.rate}x</TableCell>

                <TableCell>
                  <Chip
                    label={ot.status}
                    color={getStatusColor(ot.status)}
                  />
                </TableCell>

                <TableCell>
                  {ot.status === "pending" && (
                    <>
                      <Button
                        color="success"
                        onClick={() => updateStatus(ot.id, "approved")}
                      >
                        Approve
                      </Button>
                      <Button
                        color="error"
                        onClick={() => updateStatus(ot.id, "rejected")}
                      >
                        Reject
                      </Button>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OvertimeAdmin;